import { render, staticRenderFns } from "./add-manager.vue?vue&type=template&id=790fa4be&scoped=true&"
import script from "./add-manager.vue?vue&type=script&lang=js&"
export * from "./add-manager.vue?vue&type=script&lang=js&"
import style0 from "./add-manager.vue?vue&type=style&index=0&id=790fa4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790fa4be",
  null
  
)

export default component.exports